module.exports = __webpack_public_path__ + "img/user1.4d74693e.jpeg";